import { NavLink } from 'react-router-dom';
import { LanguageToggle } from './LanguageToggle';
import { TextSizeToggle } from './TextSizeToggle';
import { ThemeToggle } from './ThemeToggle';
import { useTranslation } from 'react-i18next';

export function TopNav() {
  const { t } = useTranslation();

  const primaryLinks = [
    { to: '/apollo', label: t('nav.apollo'), end: false },
    { to: '/', label: t('nav.dashboard'), end: true },
    { to: '/documents', label: t('nav.documents'), end: false },
    { to: '/timeline', label: t('nav.timeline'), end: false },
    { to: '/map', label: t('nav.map'), end: false },
    { to: '/atlas', label: t('nav.atlas'), end: false },
  ];

  const secondaryLinks = [
    { to: '/davinci', label: t('nav.davinci'), end: false },
    { to: '/michelangelo', label: t('nav.michelangelo'), end: false },
    { to: '/about', label: t('nav.about'), end: false },
  ];

  return (
    <header className="topnav">
      <div className="topnav-brand">
        <span className="topnav-wordmark">PURSUE</span>
        <span className="topnav-tagline">{t('pursue.logoSub')}</span>
      </div>
      <nav className="topnav-links" aria-label={t('interfaceText.mainNavigation_eb355944')}>
        {primaryLinks.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) => `topnav-link${isActive ? ' active' : ''}`}
          >
            {link.label}
          </NavLink>
        ))}
        {secondaryLinks.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) => `topnav-link${isActive ? ' active' : ''}`}
          >
            {link.label}
          </NavLink>
        ))}
      </nav>
      <div className="topnav-controls">
        <TextSizeToggle />
        <ThemeToggle />
        <LanguageToggle />
      </div>
    </header>
  );
}
